import React, { useState } from 'react';
import { ValidationProps } from 'ui';
import { SelectMultiple, SelectSingle } from 'app/area/shared/translated-components';

import { ComplexValue, LoadOptions } from 'app/types-shared';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';

import { TextConfigurationTranslation } from '../../constants';
import { endpoints } from '../../endpoints';
import { isCustomerTextSet } from '../utils/is-customer-text-set';
import { TextConfigurationItem } from '../types-store';

const textSetId = 'textSet';
const textCollectionId = 'textCollection';

interface TextFormDetailsProps {
  textItem: TextConfigurationItem;
  development: boolean;
  onTextSetChange: (value: ComplexValue<number>) => void;
  onTextCollectionChange: (values: ComplexValue<number>[]) => void;
  options: {
    [key: string]: {
      fetching: boolean;
      codes?: ComplexValue<number | string>[];
    };
  };
  loadOptions: (id: string,
    componentEndpoint: string,
    loadOptionsParams: LoadOptions,
    optionsParams?: any) => void;
  validation: { [key: string]: ValidationProps };
  translation: TextConfigurationTranslation;
  locale: string;
}

export const TextFormDetails: React.FC<TextFormDetailsProps> = ({
  textItem, development,
  onTextSetChange, onTextCollectionChange,
  options, loadOptions,
  validation, translation, locale
}) => {

  const [textSetOptions, setTextSetOptions] = useState<LoadOptions>();

  const onTextSetLoadOptions = (loadOptionsParams: LoadOptions) => {
    loadOptions(textSetId, endpoints.textSetOptions, loadOptionsParams);
    setTextSetOptions(loadOptionsParams);
  };

  const [textCollectionOptions, setTextCollectionOptions] = useState<LoadOptions>();

  const onTextCollectionLoadOptions = (loadOptionsParams: LoadOptions) => {
    loadOptions(textCollectionId, endpoints.textCollectionOptions, loadOptionsParams);
    setTextCollectionOptions(loadOptionsParams);
  };

  const addMode = !textItem || !isDefinedIncludingZero(textItem.id);
  const canEditTextCollection = !!development && !isCustomerTextSet(textItem);

  return <div className="row">
    {addMode &&
      <div className="col-lg-6 col-sm-12">
        <SelectSingle
          componentId={textSetId}
          className={undefined}
          label={translation ? { text: translation.text_set, required: true } : undefined}
          valueItem={textItem && textItem.textSet || undefined}
          onChange={onTextSetChange}
          validation={validation && validation[textSetId]}

          options={options && options[textSetId]?.codes as ComplexValue<number>[] || []}
          fetching={options && options[textSetId]?.fetching || false}
          loadOptions={textSetOptions}
          onLoadOptions={onTextSetLoadOptions}

          placeholder={translation?.search} />
      </div>}
    {(!!development || (textItem?.textCollection || []).length > 0) &&
      <div className="col-lg-6 col-sm-12">
        <SelectMultiple componentId={textCollectionId}
          className={undefined}
          label={translation ? { text: translation.text_collections, required: false } : undefined}
          valueItems={textItem?.textCollection || []}
          readOnly={!canEditTextCollection}
          onChange={onTextCollectionChange}
          validation={validation && validation[textCollectionId]}

          options={options && options[textCollectionId]?.codes as ComplexValue<number>[] || []}
          fetching={options && options[textCollectionId]?.fetching || false}
          loadOptions={textCollectionOptions}
          onLoadOptions={onTextCollectionLoadOptions}

          placeholder={translation && translation.search} 
          locale={locale} />
      </div>}
  </div>;
};
